import Alert from '@mui/joy/Alert';
import Box from '@mui/joy/Box';

import { useParams } from 'react-router-dom';

import Breadcrumbs from '@/components/Breadcrumbs';
import { ComparativeExperimentsTable } from '@/components/ComparativeExperiments/ComparativeExperimentsTable';
import { PageTitle } from '@/components/PageTitle';
import { PublicExamplesTable } from '@/components/PublicExamplesTable';
import { SessionsTable } from '@/components/SessionsTable';
import {
  TabGroup,
  TabLabel,
  TabList,
  TabPanel,
  TabPanels,
} from '@/components/Tabs/Tabs';
import { useDataset } from '@/hooks/useSwr';
import DatasetIcon from '@/icons/DatasetIcon';
import { addQueryParams } from '@/utils/add-query-params';
import {
  appComparePath,
  appPublicDatasetsPath,
  appPublicPath,
  appSessionPath,
} from '@/utils/constants';

import { NoProjects } from '../Dataset';

export function NoExamples() {
  return (
    <Box marginBottom={3}>
      <Alert variant="outlined">There are no examples yet.</Alert>
    </Box>
  );
}

export const PublicDataset = () => {
  const { datasetShareToken } = useParams();
  const datasetFetch = useDataset(undefined, { datasetShareToken });
  const dataset = datasetFetch?.data;

  return (
    <div className="px-4 py-4">
      <Breadcrumbs />
      {dataset && (
        <Box>
          <Box display="flex" alignItems={'center'} gap={2}>
            <PageTitle
              icon={<DatasetIcon />}
              description={dataset?.description}
            >
              {dataset?.name}
            </PageTitle>
          </Box>

          <TabGroup>
            <TabList>
              <TabLabel>Experiments</TabLabel>
              <TabLabel>Pairwise Experiments</TabLabel>
              <TabLabel>Examples</TabLabel>
            </TabList>
            <TabPanels>
              <TabPanel>
                <Box>
                  <SessionsTable
                    onRowClickSuffix={`/${appSessionPath}?eval=true`}
                    onRowClickPrefix={
                      datasetShareToken
                        ? `/${appPublicPath}/${datasetShareToken}/${appPublicDatasetsPath}/`
                        : undefined
                    }
                    filter={{}}
                    datasetShareToken={datasetShareToken}
                    emptyState={<NoProjects />}
                    columnVisibility={{
                      run_count: true,
                      total_tokens: false,
                    }}
                    isDatasetPage={true}
                    getCompareClickUrl={(rowSelection) => {
                      return addQueryParams(
                        `/${appPublicPath}/${datasetShareToken}/${appPublicDatasetsPath}/${appComparePath}`,
                        {
                          selectedSessions: rowSelection.join(','),
                        }
                      );
                    }}
                  />
                </Box>
              </TabPanel>
              <TabPanel>
                <ComparativeExperimentsTable
                  datasetShareToken={datasetShareToken}
                />
              </TabPanel>
              <TabPanel>
                <PublicExamplesTable
                  datasetShareToken={datasetShareToken}
                  emptyState={<NoExamples />}
                  exampleCount={dataset?.example_count}
                />
              </TabPanel>
            </TabPanels>
          </TabGroup>
        </Box>
      )}
    </div>
  );
};

export default PublicDataset;
